import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore } from 'redux/core'
import { preloadReady } from 'react-loadable'
import { StoreContext } from 'sb-redux-hook'
import { syncHistoryWithStore } from 'react-router-redux'
import { Router, browserHistory } from 'react-router'

import routes from 'redux/routes'


const init = (initialState, isDev) => {
  const { store, storeEvents } = createStore(initialState)

  console.log({ store, storeEvents, initialState, isDev })
  const renderAction  = isDev ? ReactDOM.render : ReactDOM.hydrate
  const history       = syncHistoryWithStore(browserHistory, store, {
    selectLocationState: ({ routing }) => routing,
  })

  return preloadReady()
    .then(() =>
      renderAction(
        <Provider store={store}>
          <StoreContext.Provider value={{ store, storeEvents }}>
            <Router history={history}>
              {routes}
            </Router>
          </StoreContext.Provider>
        </Provider>,
        document.getElementById('app')
      )
    )
}


export default init
